import React from "react";
import "./userAvatar.scss";

const UserAvatar = ({ url }) => (
  <div className="user-avatar">
    {url &&
      <img src={url} alt="Profile Pic" /> }
  </div>
);

export { UserAvatar };
